import { postApi } from 'api/fetchApi'
import { operations } from 'api/generated/messenger_support'

type Operation = operations['messenger_support_upload_photo_uploadPhoto']
type Response = Operation['responses']['204']['schema']

export const messengerSupportUploadPhotoApi = (formData: FormData) => {
  return postApi<Response, FormData>('/messenger/support/uploadPhoto', formData)
}
